import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { resource } from '@util/resource';
import { DWS } from '@interfaces/dws';
import { map } from 'rxjs/operators';


@Injectable({
  providedIn: 'root'
})
export class TemplateHtmlService {

  list(wineryId: string): Observable<DWS.TemplateHtmlReduced[]> {
    return resource('crm://template-html')
      .params({ wineryId})
      .get<DWS.TemplateHtmlReduced[]>();
  }

  listFilterByTrigger(trigger: string | undefined, wineryId: string): Observable<DWS.TemplateHtmlReduced[]> {
    if (!trigger) {
      return this.list(wineryId).pipe(
        map(emails => {
          emails = emails.map(email => {
            email.type = email.type + "-" + email.languageCode;
            return email;
          });
          return emails;
        })
      );
    }
    return this.list(wineryId).pipe(
      map(emails => {
        var ss = emails.filter(email => email.type.includes(trigger) || !!!trigger);
        ss = ss.map(email => {
          email.type = email.type + "-" + email.languageCode;
          return email;
        });
        return ss;
      })
    );
  }

  get(type: string, wineryId: string, langCode: string): Observable<DWS.TemplateHtml> {
    return resource('crm://template-html/type')
      .params({ type, wineryId, languageCode: langCode })
      .get<DWS.TemplateHtml>();
  }

  saveLive(type: string, value: DWS.TemplateHtml.NewBase, wineryId: string): Observable<DWS.TemplateHtml> {
    return resource('crm://template-html/type')
      .params({ type, wineryId })
      .post<DWS.TemplateHtml>(value);
  }

  saveDraft(type: string, value: DWS.TemplateHtml.NewBase, wineryId: string): Observable<DWS.TemplateHtml> {
    return resource('crm://template-html/type/draft')
      .params({ type, wineryId })
      .post<DWS.TemplateHtml>(value);
  }

  restore(type: string, wineryId: string, langCode: string): Observable<void> {
    return resource('crm://template-html/type')
      .params({ type, wineryId, languageCode: langCode })
      .delete();
  }

  deleteDraft(type: string, wineryId: string, langCode: string): Observable<DWS.TemplateHtml> {
    return resource('crm://template-html/type/draft')
      .params({ type, wineryId, languageCode: langCode })
      .delete();
  }

  getPDF(template: DWS.TemplateHtml): Observable<HttpResponse<Blob>> {
    var ss = resource('crm://template-html/get-pdf')
      .postBlob(template);
    return ss;
  }
}
